import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { WorkGetNextService, WorkMenuItemFoundationService, WorkFieldFoundationService, WorkItemFoundationService,
  FoundationTaxonomyMenuItemFModel, FoundationTaxonomyFieldFModel } from 'e5core-angular-services';

import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { WorkDeliveryService } from '../../services/work-delivery.service';

@Component({
  selector: 'e5core-ui-get-next',
  templateUrl: './e5core-ui-get-next.component.html',
  styleUrls: ['./e5core-ui-get-next.component.css']
})
export class E5coreAngularUiGetNextComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() lock: boolean ;

  id: string ;

  constructor(private workDelivery: WorkDeliveryService) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-angular-ui-get-next [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
  }

  getNext(): void {
    this.workDelivery.getNextWorkItem(this.workItem$, this.lock ? true : false).subscribe(
      wim => {},
      error => console.error(error)
    );
  }

}
